import { useQuery } from 'react-query'

import { QueryKey } from '../../../common/api'
import { dadataApi } from '../api/dadata.api'

export const useGetCompanies = (searchText?: string) => {
  return useQuery({
    queryKey: [QueryKey.DadataCompanies, searchText],
    queryFn: async () => {
      const response = await dadataApi.companyByInnName(searchText)

      return response.data
    },
    enabled: !!searchText,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  })
}
